import {
  activateDevToolsLogger,
  recordDevToolsLog,
  getDevToolsToken,
  getDevToolsBase,
} from './devToolsLogger';

/**
 * If DevTools is enabled (and our token is accepted) attach global frontend error handlers that
 * forward to /dev-tools/client-logs. Stays fully dormant otherwise (status 404/401 -> no-op).
 * Mirrors urmate.app's boot/devtools-logging.js. React render errors come via DevToolsErrorBoundary.
 */
export async function initDevToolsErrorCapture(): Promise<void> {
  if (typeof window === 'undefined') return;
  try {
    const res = await fetch(`${getDevToolsBase()}/status`, {
      headers: { 'X-DevTools-Token': getDevToolsToken() },
    });
    if (!res.ok) return;
  } catch {
    return;
  }

  activateDevToolsLogger();

  window.addEventListener('error', (event) => {
    recordDevToolsLog({
      level: 'error',
      origin: 'window.onerror',
      message: event.message || String(event.error ?? 'Unknown error'),
      stack: event.error instanceof Error ? event.error.stack : undefined,
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = (event as PromiseRejectionEvent).reason;
    recordDevToolsLog({
      level: 'error',
      origin: 'unhandledrejection',
      message: reason instanceof Error ? reason.message : String(reason),
      stack: reason instanceof Error ? reason.stack : undefined,
    });
  });
}
